import React, { useState } from 'react';
import { FiPlay, FiRotateCcw } from 'react-icons/fi';

const CodePlayground = ({ initialCode, title = 'Try it Yourself!' }) => {
  const [code, setCode] = useState(initialCode);
  const [output, setOutput] = useState('Click "Run Code" to see the output');

  const handleRun = () => {
    // This is a placeholder. In production, you'd integrate with a C# compiler API
    // or use services like .NET Fiddle, Replit API, etc.
    setOutput(`// Code execution simulation
// In production, this would compile and run C# code
// using a backend service or API

Example output for:
${code.split('\n').slice(0, 3).join('\n')}...

✅ Code compiled successfully!
📝 This is where the actual output would appear.`);
  };

  const handleReset = () => {
    setCode(initialCode);
    setOutput('Click "Run Code" to see the output');
  };

  return (
    <div className="code-playground">
      <div className="playground-header">
        <div className="playground-title">🎮 {title}</div>
        <div className="code-actions">
          <button className="code-btn" onClick={handleRun}>
            <FiPlay /> Run Code
          </button>
          <button className="code-btn secondary" onClick={handleReset}>
            <FiRotateCcw /> Reset
          </button>
        </div>
      </div>
      <div className="playground-body">
        <div className="editor-pane">
          <textarea
            value={code}
            onChange={(e) => setCode(e.target.value)}
            style={{
              width: '100%',
              height: '100%',
              padding: '24px',
              background: '#1E1E1E',
              color: '#D4D4D4',
              border: 'none',
              fontFamily: "'Fira Code', monospace",
              fontSize: '14px',
              lineHeight: '1.6',
              resize: 'none',
              outline: 'none'
            }}
            spellCheck={false}
          />
        </div>
        <div className="output-pane">
          <div style={{ whiteSpace: 'pre-wrap', fontFamily: "'Fira Code', monospace", fontSize: '14px' }}>
            {output}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CodePlayground;

